import { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import avatar from "../../assets/profil.png";
import perso from "../../assets/perso.png";
import "./styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket, faUser, faPenToSquare, faBriefcase, faListCheck, faChevronRight, faMagnifyingGlass, faClipboardList } from "@fortawesome/free-solid-svg-icons";
import LoginModal from "../LoginModal";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";
import JobModalForm from "../JobModalForm";
import InscriptionClient from "../InscriptionClient";
import InscriptionPrestataire from "../InscriptionPrestataire";
import InscriptionDonneurOrdre from "../InscriptionDonneurOrdre";
import ForgotPassword from "../ForgotPassword";
import useIsMobile from "../../hooks/useIsMobile";

export default function HeaderV2() {
    const [activeModal, setActiveModal] = useState(null);
    const [pendingFormProjet, setPendingFormProjet] = useState(null); // 👉 pour stocker le projet à envoyer après inscription

    const location = useLocation();
    const isHome = location.pathname === "/";
    const isPrestataire = location.pathname === "/espace-prestataire";
    const isDonneurOrdre = location.pathname === "/espace-donneur-ordre";
    const [signupType, setSignupType] = useState(null);
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const isMobile = useIsMobile();
    const handleLogout = () => {
        dispatch(logout());
    };
    const navigate = useNavigate();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const sections = [
        { label: "Je cherche un pro", path: "/" },
        { label: "Je propose mes services", path: "/espace-prestataire" },
        { label: "Je suis donneur d'Ordre", path: "/espace-donneur-ordre" },
        // { label: "CGU", path: "/cgu" }
    ];

    const activeSection =
        sections.find((s) => location.pathname === s.path) || sections[0];

    // 👉 écoute l’événement openRegisterModal
    useEffect(() => {
        const handler = (e) => {
            setPendingFormProjet(e.detail.form);
            setActiveModal("signup");
        };
        window.addEventListener("openRegisterModal", handler);
        return () => window.removeEventListener("openRegisterModal", handler);
    }, []);
    useEffect(() => {
        setMobileMenuOpen(false);
    }, [location.pathname]);

    return (
        <header
            className={
                !isPrestataire && !isDonneurOrdre
                    ? "header"
                    : isPrestataire
                        ? "header presta"
                        : "header donneur-ordre"
            }
        >
            <div className="header-content">
                {/* Logo */}
                <div className="logo">
                    <a
                        href={
                            isPrestataire
                                ? "/espace-prestataire"
                                : isDonneurOrdre
                                    ? "/espace-donneur-ordre"
                                    : "/"
                        }
                    >
                        <img src={logo} alt="Logo Intereseaux" className="logo-img" />
                    </a>
                </div>

                {/* Liens navigation */}

                <div className="mobile-nav">
                    {!user ? (
                        <>

                            {/* <div style={{ display: "flex", justifyContent: "space-between", padding: "10px" }}>
                                    <div onClick={() => navigate("/")} style={{ display: "flex", flexDirection: "column", width: "100px", height: "100px", backgroundColor: "#1666fb",  color: "white", verticalAlign: "middle", justifyContent: "center", textAlign: "center" }}>
                                        <FontAwesomeIcon style={{ fontSize: "1.8em" }} icon={faMagnifyingGlass} />
                                        <span style={{ fontSize: "0.9em" }}>Je cherche un pro</span>
                                        <p>Trouvez des professionnels qualifiés près de chez vous</p>
                                    </div>
                                    <div onClick={() => navigate("/espace-prestataire")} style={{ display: "flex", flexDirection: "column", width: "100px", height: "100px", backgroundColor: "#25ac8c",  color: "white", verticalAlign: "middle", justifyContent: "center", textAlign: "center" }}>
                                        <FontAwesomeIcon style={{ fontSize: "1.8em" }} icon={faBriefcase} />
                                        <span style={{ fontSize: "0.9em" }}>Je propose mes services</span>
                                        <p>Développez votre activité et trouvez de nouveaux clients</p>
                                    </div>
                                    <div onClick={() => navigate("/espace-donneur-ordre")} style={{ display: "flex", flexDirection: "column", width: "100px", height: "100px", backgroundColor: "#7b38fa",  color: "white", verticalAlign: "middle", justifyContent: "center", textAlign: "center" }}>
                                        <FontAwesomeIcon style={{ fontSize: "1.8em" }} icon={faClipboardList} />
                                        <span style={{ fontSize: "0.8em" }}>Je suis donneur d'ordre (entreprise ou colléctivité)</span>
                                        <p>Trouvez rapidement des prestataires qualifiés pour vos projets</p>
                                    </div>
                                </div> */}
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    flexWrap: "nowrap",
                                    gap: "8px",
                                    padding: "10px 5px",
                                    width: "100%",
                                    boxSizing: "border-box",
                                    overflow: "hidden",
                                }}
                            >
                                {/* Je cherche un pro */}
                                <div
                                    onClick={() => navigate("/")}
                                    style={{
                                        flex: "1 1 0",
                                        minWidth: 0,
                                        aspectRatio: "1 / 1",
                                        boxSizing: "border-box",
                                        padding: "2px",
                                        backgroundColor: "#f8f9fb",
                                        border: "1px solid #e1e5eb",
                                        borderRadius: "9px",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        //justifyContent: "center",
                                        textAlign: "center",
                                        cursor: "pointer",
                                        boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
                                    }}
                                >
                                    <div
                                        style={{
                                            width: "40%",
                                            aspectRatio: "1 / 1",
                                            borderRadius: "50%",
                                            backgroundColor: "#1666fb",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            marginBottom: "6px",
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faMagnifyingGlass}
                                            style={{
                                                color: "white",
                                                fontSize: "0.9em",
                                            }}
                                        />
                                    </div>

                                    <span
                                        style={{
                                            color: "#174ca8",
                                            fontSize: "0.6em",
                                            fontWeight: "600",
                                            lineHeight: "1.2",
                                            marginBottom: "4px",
                                        }}
                                    >
                                        Je cherche un pro
                                    </span>

                                    <p
                                        style={{
                                            color: "#333",
                                            fontSize: "0.5em",
                                            lineHeight: "1.3",
                                            margin: 0,
                                        }}
                                    >
                                        Trouvez des professionnels
                                        <br />
                                        qualifiés près de chez vous
                                    </p>
                                </div>

                                {/* Je propose mes services */}
                                <div
                                    onClick={() => navigate("/espace-prestataire")}
                                    style={{
                                        flex: "1 1 0",
                                        minWidth: 0,
                                        aspectRatio: "1 / 1",
                                        boxSizing: "border-box",
                                        padding: "2px",
                                        backgroundColor: "#f8fbfa",
                                        border: "1px solid #e1e5eb",
                                        borderRadius: "9px",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        //justifyContent: "center",
                                        textAlign: "center",
                                        cursor: "pointer",
                                        boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
                                    }}
                                >
                                    <div
                                        style={{
                                            width: "40%",
                                            aspectRatio: "1 / 1",
                                            borderRadius: "50%",
                                            backgroundColor: "#25ac8c",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            marginBottom: "6px",
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faBriefcase}
                                            style={{
                                                color: "white",
                                                fontSize: "0.9em",
                                            }}
                                        />
                                    </div>

                                    <span
                                        style={{
                                            color: "#16836c",
                                            fontSize: "0.6em",
                                            fontWeight: "600",
                                            lineHeight: "1.2",
                                            marginBottom: "4px",
                                        }}
                                    >
                                        Je propose mes services
                                    </span>

                                    <p
                                        style={{
                                            color: "#333",
                                            fontSize: "0.6em",
                                            lineHeight: "1.3",
                                            margin: 0,
                                        }}
                                    >
                                        Développez votre activité
                                        et trouvez de nouveaux clients
                                    </p>
                                </div>

                                {/* Je suis donneur d'ordre */}
                                <div
                                    onClick={() => navigate("/espace-donneur-ordre")}
                                    style={{
                                        flex: "1 1 0",
                                        minWidth: 0,
                                        aspectRatio: "1 / 1",
                                        boxSizing: "border-box",
                                        padding: "2px",
                                        backgroundColor: "#faf9fd",
                                        border: "1px solid #e1e5eb",
                                        borderRadius: "9px",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        textAlign: "center",
                                        cursor: "pointer",
                                        boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
                                    }}
                                >
                                    <div
                                        style={{
                                            width: "40%",
                                            aspectRatio: "1 / 1",
                                            borderRadius: "50%",
                                            backgroundColor: "#7b38fa",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faClipboardList}
                                            style={{
                                                color: "white",
                                                fontSize: "0.9em",
                                            }}
                                        />
                                    </div>

                                    <span
                                        style={{
                                            color: "#6330c9",
                                            fontSize: "0.6em",
                                            fontWeight: "600",
                                            lineHeight: "1.15",
                                            marginBottom: "4px",
                                        }}
                                    >
                                        Je suis donneur d'ordre<br/>
                                        (entreprise ou collectivité)
                                    </span>

                                    <p
                                        style={{
                                            color: "#333",
                                            fontSize: "0.5em",
                                            lineHeight: "1.3",
                                            margin: 0,
                                        }}
                                    >
                                        Trouvez rapidement des prestataires
                                        qualifiés pour vos projets
                                    </p>
                                </div>
                            </div>


                            <div style={{ display: "flex", justifyContent: "space-around" }}>

                                <div style={{ display: "flex", flexDirection: "column", width: "35%", margin: "10px" }} >
                                    <p style={{ textAlign: "center", margin: 0 }}><span style={{ fontWeight: "bold" }}>100% GRATUIT</span> Sans engagement</p>

                                    <button onClick={() => setActiveModal("login")} style={{ backgroundColor: "#1c5cf2", color: "white", borderRadius: "20px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px" }}>Se connecter</button>
                                    <button onClick={() => {
                                        setSignupType(null);
                                        setActiveModal("signup-choice");
                                    }} style={{ backgroundColor: "#25ac8c", color: "white", borderRadius: "20px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px" }}>Créer un compte</button>
                                </div>
                                <div style={{ width: "35%" }}><img src={perso} alt="logo perso" style={{ width: "100%" }} /></div>
                            </div>


                        </>
                    ) : (
                        /* === USER CONNECTÉ === */
                        <div className="mobile-auth-actions">
                            <NavLink
                                to="/dashboard"
                                className={({ isActive }) =>
                                    isActive ? "nav-item active" : "nav-item"
                                }
                            >
                                Mon tableau de bord
                            </NavLink>

                            <button
                                className="nav-item"
                                onClick={handleLogout}
                            >
                                <FontAwesomeIcon icon={faRightFromBracket} /> Déconnexion
                            </button>
                        </div>
                    )}
                </div>



            </div>

            {/* Modals */}
            {activeModal === "login" && (
                <LoginModal
                    onClose={() => setActiveModal(null)}
                    onSwitch={() => setActiveModal("signup-choice")}
                    openForgotPassword={() => setActiveModal("forgot-password")}
                />
            )}
            {
                activeModal === "forgot-password" && (
                    <ForgotPassword onClose={() => setActiveModal(null)} />
                )
            }

            {activeModal === "signup-choice" && (
                <div className="modal-overlay">
                    <div className="modal-content signup-choice">
                        <div style={{ backgroundColor: "#e7eafd", borderRadius: "50%", width: "50px", height: "50px", display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", margin: "auto", fontSize: "1.5em" }}><FontAwesomeIcon icon={faPenToSquare} color="#5b71ff" /></div>
                        <h2>Je souhaite m’inscrire</h2>
                        <p> en tant que :</p>

                        <div className="choice-buttons">
                            <div
                                onClick={() => {
                                    setSignupType("client");
                                    setActiveModal("signup");
                                }}
                                style={{ display: "flex", backgroundColor: "#f3f6fd", verticalAlign: "middle", alignItems: "center", borderRadius: "15px" }}

                            >
                                <div style={{ backgroundColor: "#d6e2fa", borderRadius: "50%", width: "50px", height: "50px", display: "flex", alignItems: "center", verticalAlign: "middle", justifyContent: "center", margin: "15px", padding: "15px", fontSize: "1.5em" }}><FontAwesomeIcon icon={faUser} color="#416ae8" /></div>
                                <div style={{ display: "flex", flexDirection: "column", textAlign: "left", width: "stretch" }}>
                                    <p style={{ color: "#416ae8", margin: "0", textAlign: "left", fontSize: "1.3em", fontWeight: "bolder" }} >Client</p>
                                    <p style={{ margin: "0", textAlign: "left" }}>Je recherche un prestataire</p>
                                </div>
                                <div style={{ padding: "10px" }}><FontAwesomeIcon icon={faChevronRight} color="#416ae8" /></div>
                            </div>

                            <div
                                onClick={() => {
                                    setSignupType("prestataire");
                                    setActiveModal("signup");
                                }}
                                style={{ display: "flex", backgroundColor: "#f5faf3", verticalAlign: "middle", alignItems: "center", borderRadius: "15px" }}

                            >
                                <div style={{ backgroundColor: " #d9ecd6", borderRadius: "50%", width: "50px", height: "50px", display: "flex", alignItems: "center", verticalAlign: "middle", justifyContent: "center", margin: "15px", padding: "15px", fontSize: "1.5em" }}><FontAwesomeIcon icon={faBriefcase} color="#2c723c" /></div>
                                <div style={{ display: "flex", flexDirection: "column", textAlign: "left", width: "stretch" }}>
                                    <p style={{ color: "#2c723c", margin: "0", textAlign: "left", fontSize: "1.3em", fontWeight: "bolder" }} >Prestataire</p>
                                    <p style={{ margin: "0", textAlign: "left" }}>Je propose mes services</p>
                                </div>
                                <div style={{ padding: "10px" }}><FontAwesomeIcon icon={faChevronRight} color="#2c723c" /></div>

                            </div>

                            <div
                                onClick={() => {
                                    setSignupType("donneur_ordre");
                                    setActiveModal("signup");
                                }}
                                style={{ display: "flex", backgroundColor: "#fdf8f2", verticalAlign: "middle", alignItems: "center", borderRadius: "15px" }}
                            >
                                <div style={{ backgroundColor: " #fee6cc", borderRadius: "50%", width: "50px", height: "50px", display: "flex", alignItems: "center", verticalAlign: "middle", justifyContent: "center", margin: "15px", padding: "15px", fontSize: "1.5em" }}><FontAwesomeIcon icon={faListCheck} color="#f38411" /></div>
                                <div style={{ display: "flex", flexDirection: "column", textAlign: "left", width: "stretch" }}>
                                    <p style={{ color: "#f38411", margin: "0", textAlign: "left", fontSize: "1.3em", fontWeight: "bolder" }} >Donneur d'ordre</p>
                                    <p style={{ margin: "0", textAlign: "left" }}>Je dépose un appel d'offres</p>
                                </div>
                                <div style={{ padding: "10px" }}><FontAwesomeIcon icon={faChevronRight} color="#f38411" /></div>

                            </div>
                        </div>

                        <button
                            className="btn-primary"
                            onClick={() => setActiveModal(null)}
                        >
                            Annuler
                        </button>
                    </div>

                    <style jsx>{`
            .signup-choice {
                text-align: center;
                padding: 20px;
            }
            .choice-buttons {
                display: flex;
                flex-direction: column;
                gap: 10px;
                margin-top: 15px;
            }
        `}</style>
                </div>
            )}

            {activeModal === "signup" && signupType === "client" && (
                <InscriptionClient
                    onClose={() => setActiveModal(null)}
                    onSwitch={() => setActiveModal("login")}
                    formDataProjet={pendingFormProjet}
                />
            )}

            {activeModal === "signup" && signupType === "prestataire" && (
                <InscriptionPrestataire
                    onClose={() => setActiveModal(null)}
                    onSwitch={() => setActiveModal("login")}
                />
            )}

            {activeModal === "signup" && signupType === "donneur_ordre" && (
                <InscriptionDonneurOrdre
                    onClose={() => setActiveModal(null)}
                    onSwitch={() => setActiveModal("login")}
                />
            )}

            {activeModal === "jobForm" && (
                <JobModalForm onClose={() => setActiveModal(null)} />
            )}
        </header>
    );
}
